const getDefaultLocalisationForActivital = () => {
  return {
    lat: 47.18804870177507,
    lng: 4.0685483848612,
  };
};

export { getDefaultLocalisationForActivital };
